export default __webpack_public_path__ + "locales/lv/Errors.json?hash=1bab52ce99e100f7c306693a25554486";